import PageHero from '@/components/sections/shared/PageHero'
import Icon from '@/components/ui/Icon'
import { useData } from '@/hooks/useLocale'

/** The guide's photo hero, with the box that searches the manual below it. */
export default function GuideHeroSection({ query, onQuery }) {
  const { GUIDE } = useData()

  return (
    <PageHero eyebrow={GUIDE.eyebrow} title={GUIDE.title} text={GUIDE.text}>
      <label className="mt-3.5 flex h-14 max-w-140 items-center gap-3 rounded-[18px] bg-white px-[18px] text-subtle shadow-[0_20px_40px_-20px_rgba(0,0,0,.5)] focus-within:ring-2 focus-within:ring-sky">
        <Icon name="search" size={20} />
        <input
          type="search"
          value={query}
          onChange={(e) => onQuery(e.target.value)}
          placeholder={GUIDE.search.placeholder}
          aria-label={GUIDE.search.label}
          className="min-w-0 flex-1 bg-transparent text-base text-ink outline-none placeholder:text-subtle"
        />
      </label>
    </PageHero>
  )
}
